import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import { IExtension } from '@tencent/ark-extensions';
import { IExportImage } from '@src/js/common/ark-extensions/dc-components/docs-component-export-image/interface';

export async function showExportImage(options: any): Promise<IExtension> {
    await ArkLoader.extensionService.scanAndHandleExtensions([componentConfig]);
    const collaborationExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    if (options.isLoadingExportImage) {
        (collaborationExtension as IExportImage)?.prepare?.(options);
    } else {
        collaborationExtension.show(options);
    }
    return collaborationExtension;
}
